import React from "react";
import PropTypes from 'prop-types';

import RenderComponentProto from "../../render-component-proto";

import InputInlineEditable from 'core/gd-components/input-inline-editable/input-inline-editable';

export default class StringField extends RenderComponentProto {

    static props = {
        id: PropTypes.string, // not required now because of form field .isRequired,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,
        onChange: PropTypes.func,
        //old
        params: PropTypes.object,
        onFocusCallback: PropTypes.func,
        onBlurCallback: PropTypes.func,
        stateless: PropTypes.bool // ????
    }

    static defaultProps = {
        canEdit: false
    }

    state = {
        isEditing: false,
        value: this.props.value
    }

    onChange = (newValue) => {
        if (!newValue) newValue = '';

        const { onChange } = this.props;
        this.setState({value: newValue}, ()=>{
            if (onChange) onChange(newValue)
        });
    }

    onFocus = (e) => {
        this.setState({isEditing: true}, ()=> {
            if (this.props.onFocus) this.props.onFocus(e)
        });
    }

    onBlur = (e) => {
        this.setState({isEditing: false}, ()=>{
            if (this.props.onBlur) this.props.onBlur(e);
        });
    }

    render() {

        let classes;

        if (this.props.renderMode === 'edit') {
            classes = Classes('gd-field-string gd-custom-field-input-based','view','edit',{
                'disabled': this.props.canEdit === false,
            });
        } else {
            classes = Classes('gd-field-string gd-custom-field-input-based',this.props.renderMode,{
                'edit': this.state.isEditing,
                'disabled': this.props.canEdit === false,
                'not-set': !this.state.value
            });
        }

        const borderComponent = this.state.value && this.props.renderMode === 'list' && !this.state.isEditing ? <div className="value-border">{this.state.value}</div> : null

        return (
            <div className={classes}>
                <InputInlineEditable value={this.state.value}
                                     disabled={(this.props.canEdit === false)}
                                     onChange={this.onChange}
                                     onFocus={this.onFocus}
                                     onBlur={this.onBlur}
                                     commitDelay={2000}/>
                {borderComponent}
            </div>
        );
    }

}